import { apiClient } from './api';
import { BookingRequest } from '../types/booking';
import { ApiResponse } from '../types/auth';

export const adminService = {
  async getBookings(): Promise<ApiResponse<BookingRequest[]>> {
    try {
      const response = await apiClient.get<ApiResponse<BookingRequest[]>>('/admin/bookings');
      return response.data;
    } catch (error: unknown) {
      throw error;
    }
  },

  async getBooking(id: number): Promise<ApiResponse<BookingRequest>> {
    try {
      const response = await apiClient.get<ApiResponse<BookingRequest>>(`/admin/bookings/${id}`);
      return response.data;
    } catch (error: unknown) {
      throw error;
    }
  },

  async updateBookingStatus(id: number, status: string): Promise<ApiResponse<BookingRequest>> {
    try {
      const response = await apiClient.patch<ApiResponse<BookingRequest>>(`/admin/bookings/${id}/status`, {
        status,
      });
      return response.data;
    } catch (error: unknown) {
      throw error;
    }
  },

  async deleteBooking(id: number): Promise<ApiResponse<void>> {
    try {
      const response = await apiClient.delete<ApiResponse<void>>(`/admin/bookings/${id}`);
      return response.data;
    } catch (error: unknown) {
      throw error;
    }
  },

  async changePassword(currentPassword: string, newPassword: string, newPasswordConfirmation: string): Promise<ApiResponse<void>> {
    try {
      const response = await apiClient.post<ApiResponse<void>>('/auth/change-password', {
        current_password: currentPassword,
        new_password: newPassword,
        new_password_confirmation: newPasswordConfirmation,
      });
      return response.data;
    } catch (error: unknown) {
      throw error;
    }
  },
};
